module.exports = __webpack_public_path__ + "411dff252e2f4f4948b11c71319722d9.pdf";